/* Linenvale theme.js */
(function () {
  'use strict';

  /* ---- Mobile nav -------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-nav]');
      if (nav) nav.classList.toggle('is-open');
      return;
    }
    // Mobile: tap a parent item to open its submenu instead of following the link
    if (window.innerWidth <= 989) {
      var link = e.target.closest('.nav__item > .nav__link');
      if (link && link.parentElement.querySelector('.mega')) {
        e.preventDefault();
        link.parentElement.classList.toggle('is-open');
      }
    }
  });

  /* ---- Carousels --------------------------------------------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    root.querySelectorAll('[data-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-scroll') === 'next' ? 1 : -1;
        var first = track.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 16 : 240;
        track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      });
    });
  }
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);

  /* ---- Quantity + variant on product page --------------------------- */
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url.toString());
      var priceEl = document.querySelector('[data-variant-price]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      var btn = document.querySelector('[data-add-button]');
      if (btn) {
        var available = opt.dataset.available === 'true';
        btn.disabled = !available;
        btn.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
  });

  /* ---- Product gallery thumbs --------------------------------------- */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (main) {
        main.src = thumb.dataset.thumb;
        main.srcset = '';
      }
    });
  });

  /* ---- Ajax add to cart from product cards -------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-cart-total]').forEach(function (el) {
          el.textContent = formatMoney(cart.total_price);
        });
        if (btn) { btn.textContent = 'Added'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400); }
      })
      .catch(function () {
        if (btn) { btn.textContent = original; btn.disabled = false; }
        form.submit();
      });
  });

  function formatMoney(cents) {
    var symbol = (window.LinenvaleMoneyFormat || '£{{amount}}').replace(/\{\{.*?\}\}/, '');
    return symbol + (cents / 100).toFixed(2);
  }
})();

/* ---- Two-pane mega menu ------------------------------------------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-megax-root]');
  if (!root) return;
  var panel = root.querySelector('[data-megax]');
  var toggle = root.querySelector('[data-megax-toggle]');
  if (!panel || !toggle) return;

  function open(state) {
    panel.hidden = !state;
    root.classList.toggle('is-open', state);
    toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    open(panel.hidden);
  });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) open(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') open(false);
  });

  function activate(btn) {
    var id = btn.getAttribute('data-pane');
    panel.querySelectorAll('.megax__rail-item').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panel.querySelectorAll('.megax__pane').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-pane-id') === id);
    });
  }

  panel.querySelectorAll('.megax__rail-item').forEach(function (btn) {
    btn.addEventListener('mouseenter', function () { activate(btn); });
    btn.addEventListener('focus', function () { activate(btn); });
    btn.addEventListener('click', function (e) { e.preventDefault(); activate(btn); });
  });
})();
